export default {
      id: "companion-logo-usage",
      viewBox: "0 0 321.53651 77.91217",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#companion-logo",
      toString: function () {
        return this.url;
      }
    }